import { DrawingEdge } from '@common/models';

export enum CustomSideType {
    RADIUS_OUT = 'RadiusOut',
    BUMP_OUT = 'BumpOut',
    REMOVE_CUSTOM_SIDE = 'RemoveCustomSide',
}

export const containsBumpOut = (edge: DrawingEdge): boolean => edge?.customSideType === CustomSideType.BUMP_OUT;

export const containsRadiusOut = (edge: DrawingEdge): boolean => edge?.customSideType === CustomSideType.RADIUS_OUT;
